import React from 'react'
import { Div, H2, P, Icon } from '@drifthq/tide-core'

import './style.css'

export default class EducationCarousel extends React.Component {
  componentDidMount() {
    const { cardList } = this.props
    const lastCardIndex = (cardList.length - 1)

    const carouselList = document.querySelector('.carousel__list')
    const carouselItems = document.querySelectorAll('.carousel__item')
    const prevButton = document.querySelector('.carousel__prev')
    const nextButton = document.querySelector('.carousel__next')
    const elems = Array.from(carouselItems)

    carouselList.addEventListener('click', function(event) {
      var newActive = event.target
      var isItem = newActive.closest('.carousel__item')

      if (!isItem || newActive.classList.contains('carousel__item_active')) {
        return
      }

      update(isItem)
    })

    prevButton.addEventListener('click', function() {
      update(elems.find(elem => elem.dataset.pos === '1'))
    })

    nextButton.addEventListener('click', function() {
      update(elems.find(elem => elem.dataset.pos === lastCardIndex.toString()))
    })

    const update = function(newActiveItem) {
      const current = elems.find(elem => elem.dataset.pos === '0')
      const newActivePos = newActiveItem.dataset.pos

      current.classList.remove('carousel__item_active')
      elems.forEach(item => {
        var itemPos = parseInt(item.dataset.pos, 10)
        item.dataset.pos = getPos(itemPos, newActivePos)
      })
    }

    const getPos = function(current, activePos) {
      if (activePos === lastCardIndex.toString()) {
        return (current + 1) % cardList.length
      } else if (current === 0) {
        return lastCardIndex
      } else {
        return current - 1
      }
    }
  }
  render() {
    const { cardList } = this.props
    
    return (
      <div className="carousel">
        <div className="carousel__button carousel__prev">
          <Icon name="arrow-1-left"/>
        </div>
        <div className="carousel__button carousel__next">
          <Icon name="arrow-1-right"/>
        </div>
        <ul className="carousel__list">
          {cardList.map((cardData, i) => (
            <li className="carousel__item" data-pos={i} key={`carousel-item-${i}`}>
              <Div className="item">
                {cardData.imgSrc && <img src={cardData.imgSrc} alt="" />}
                <Div className="text-wrapper">
                  {cardData.header && <H2>{cardData.header}</H2>}
                  {cardData.copy && <P>{cardData.copy}</P>}
                </Div>
              </Div>
            </li>
            )
          )}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/EducationCarousel/index.js